// Libs
import styled, { css } from 'styled-components'

// Comps
import { Section } from '../Section'
import { H3, P } from '../Headings'
import { CTA } from '../CTA'
import { show } from '../../utils'

// Defs
interface Props {
  smallHeader?: string
  largeHeader?: string
  bgImage: string
}

// Styles
import { bowedHeroShortSectionStyles } from './bowedHeroShortSectionStyles'

const Container = styled(Section)<Props>`
  ${bowedHeroShortSectionStyles}
`

export const BowedHeroShortSection: React.FC<Props> = (props) => {
  // Props
  const { smallHeader, largeHeader, bgImage } = props

  // ..
  return (
    <Container className="BowedHero" unlockWidthConstraint bgImage={bgImage}>
      {/* Full screen width background */}
      <div className="background">{/* <img src={bgImage} /> */}</div>
      {/* Background with bow */}
      <div className="content-container">
        <div className="heroText">
          <H3 className="heroHeader">{largeHeader || ''}</H3>
          <P className="heroSmallHeader">{smallHeader || ''}</P>
        </div>
      </div>
    </Container>
  )
}
